<template>
  <div>
    <!-- <Coupons />-->
    <shop-header :store-id="storeid" />
    <section class="bg-white position-sticky" style="top:-1px;z-index:2">
      <div class="container-fluid" :style="desktopStyles.nav">
        <div class="container" ref="container" v-if="storeMenu">
          <resturant-menu :categories="storeMenu.Categories" />
        </div>
      </div>
    </section>
    <div class="container root">
      <div class="row main-container" v-if="storeMenu">
        <main :class="productListClass">
          <ProductList
            :menu="JSON.parse(JSON.stringify(storeMenu))"
            @update-containerWidth="p=>updateWidth(p)"
          />
        </main>
        <aside :class="shoppingCartClass" id="shopping-cart">
          <div
            class="category-title"
            v-if="storeMenu.Categories && storeMenu.Categories.length > 0"
          />
          <ShoppingCart />
        </aside>
      </div>
    </div>
    <shopfooter />
  </div>
</template>
<script>
import ProductList from "./products/ProductList";
import ShoppingCart from "./shopping-cart/ShoppingCart";
import ResturantMenu from "./../shared/menu";
import ShopHeader from "./partials/shopheader";
import shopfooter from "./../shared/shopfooter";
import { mapMutations, mapActions, mapGetters } from "vuex";
export default {
  components: {
    ProductList,
    ShoppingCart,
    ResturantMenu,
    ShopHeader,
    shopfooter
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      productListClass: "col-xl-8 col-md-8 col-sm-6",
      shoppingCartClass: "col-xl-4 col-md-4 col-sm-6"
    };
  },
  async created() {},
  computed: {
    ...mapGetters(["storeMenu", "desktopStyles"])
  },
  mounted() {
    this.setStore(this.storeid);
    this.initStore(this.storeid);
    this.getStoreMenu(this.storeid);
  },
  methods: {
    ...mapMutations(["setStore", "setStoreLoaded"]),
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "insertErrorlog",
      "redirectToErrorPage"
    ]),
    updateWidth(width) {
      if (width > 992) {
        this.productListClass = "col-xl-8 col-md-7 col-sm-6";
        this.shoppingCartClass = "col-xl-4 col-md-5 col-sm-6";
      } else {
        this.productListClass = "col-xl-6 col-md-6 col-sm-6";
        this.shoppingCartClass = "col-xl-6 col-md-6 col-sm-6";
      }
    }
  }
};
</script>
